module.exports = true;



//////////////////
// WEBPACK FOOTER
// C:/Source/hackathon/hackathon/web-app/node_modules/core-js/library/modules/_library.js
// module id = ../../../node_modules/core-js/library/modules/_library.js
// module chunks = 0